import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {getSortedFavoritePicks} from 'selectors/favoritePicks';
import Pick from 'components/Cards/Pick';
import {TriangleIcon} from 'icons';

import './favoritePicks.scss';

const FavoritePicks = ({favoritePicks}) => (
  <div>
    <div className="favorite-picks-title">
      Your favorite picks
      <Link to="/stats/settled">
        Stats
        <TriangleIcon />
      </Link>
    </div>
    {favoritePicks.length ? (
      favoritePicks.map(pick => <Pick key={pick.id} pick={pick} />)
    ) : (
      <p className="message">You don&apos;t have favorite picks</p>
    )}
  </div>
);

FavoritePicks.propTypes = {};

export default connect(state => ({
  favoritePicks: getSortedFavoritePicks(state),
}))(FavoritePicks);
